/**
 * @file index.tsx
 *
 * @fileoverview Shows an empty box placeholder for the attachments section of organizations.
 */
import { FormattedMessage, useIntl } from 'react-intl';
import { OrganizationWidgetsBoxLabel } from '~/jobiqo/components/Organization/Widgets/BoxLabel';
import { OrganizationProfile } from '~/jobiqo/types/types';
import { FlexItems } from '~/vcl/atoms/06-layout/03-flex';
import { Box } from '~/vcl/atoms/07-box';
import { EmptyElement } from '~/vcl/molecules/02-empty';
import { EditLink } from '../../EditLink';

export interface OrganizationAttachmentsWidgetEmptyProps {
  /**
   * The current organization profile.
   */
  organization: OrganizationProfile;
  /**
   * The current box id.
   */
  boxId: string | undefined;
}

export const OrganizationAttachmentsWidgetEmpty = ({
  organization,
  boxId,
}: OrganizationAttachmentsWidgetEmptyProps) => {
  const intl = useIntl();

  if (!organization?.canEdit) {
    return null;
  }

  return (
    <Box
      label={
        <OrganizationWidgetsBoxLabel>
          {intl.formatMessage({
            id: 'organization_attachments_label',
            defaultMessage: 'Organization attachments',
          })}
        </OrganizationWidgetsBoxLabel>
      }
    >
      <FlexItems justifyContent="flex-end">
        <EditLink organization={organization} boxId={boxId} />
      </FlexItems>
      <EmptyElement>
        <FormattedMessage
          id="organization_attachments_empty"
          defaultMessage="Upload your organizations attachments here. Listing benefits shows applicants that you are investing in your employees well-being."
        />
      </EmptyElement>
    </Box>
  );
};
